/**
 * No debug output in the production browser console (CASA finding 21).
 *
 * This app ships around seventy `console.*` calls — `react-scripts build` has
 * no `drop_console`, so every one of them survives minification. Two printed
 * things that should never reach a production console: the whole sign-in
 * response object, and the session flag on every render. In production they
 * only show someone with devtools open how the app works inside.
 *
 * `warn` and `error` stay. That is how genuine failures surface, and removing
 * them would hide real problems rather than debug noise.
 *
 * Keyed on the deploy environment, not NODE_ENV — every `react-scripts build`
 * runs as NODE_ENV=production, and develop should keep its logs.
 *
 * Mirrors `frontend/src/utils/productionConsole.ts`, deliberately: the two
 * apps answer the same finding, so they should answer it the same way.
 */
export const silenceDebugConsole = (env: string | undefined): void => {
  if (env !== 'production') return;

  const silent = (): void => undefined;
  console.log = silent;
  console.info = silent;
  console.debug = silent;
};
